/* eslint-disable react/prefer-stateless-function */
import { PureComponent } from "react";
import { withMarkdownParser } from "../../utilities";

class TripItineraryItem extends PureComponent {}

export default withMarkdownParser(TripItineraryItem, {
  textFields: ["Description"],
});
